import React from 'react';
import { CWrap } from './styled';
import { EventShort } from 'types';
import { BASE_NEWS_COUNT } from 'containers/pages/news-list/NewsList';
import EventCard from '../event-card';

export interface Props {
    items: EventShort[];
    secondary?: boolean;
    hasTags?: boolean;
    target?: string;
    isAcademy?: boolean;
}

export const EventCardPlate: React.FC<Props> = ({
    items,
    secondary,
    hasTags,
    target,
    isAcademy,
}): JSX.Element => (
    <CWrap>
        {items.map(({ image, name, groupName, startDate }, index) => (
            <EventCard
                key={name}
                data={{
                    imageURL: image?.fileLink ?? '',
                    title: name,
                    link: `/events/${groupName}/`,
                }}
                isFirstInBlock={index % BASE_NEWS_COUNT === 0}
                secondary={secondary}
                date={hasTags ? startDate : undefined}
                target={target}
                isAcademy={isAcademy}
            />
        ))}
    </CWrap>
);

export default EventCardPlate;
